import { render, staticRenderFns } from "./ErpExtractDetails.vue?vue&type=template&id=6ff2a7cc&scoped=true"
import script from "./ErpExtractDetails.vue?vue&type=script&lang=js"
export * from "./ErpExtractDetails.vue?vue&type=script&lang=js"
import style0 from "./ErpExtractDetails.vue?vue&type=style&index=0&id=6ff2a7cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff2a7cc",
  null
  
)

export default component.exports